<input
  *ngIf="tipo === 'usb'"
  (window:keypress)="leerUSB($event)"
  style="display: none"
  type="text"
  autofocus
/>

<div *ngIf="tipo === 'camara'" class="camara">
  <mat-spinner diameter="50" *ngIf="!escaner.isStarted"></mat-spinner>
  <barcode-scanner-livestream
    #escaner
    (valueChanges)="escaneo.next($event)"
  ></barcode-scanner-livestream>
</div>
